import { cr } from "fire-wind-water/core";
import { Text } from "./text";
import { Textarea } from "./textarea";
import { Datetime } from "./datetime";
import { Radio } from "./radio";
import { Checkbox } from "./checkbox";
import { CheckboxSelect } from "./checkboxselect";
import { Select } from "./select";
import { UploadFile } from "./upload";

export function createField(d) {
  if (d.fieldType === "TEXT") {
    const text = parseInt(d.displayType) === 1 ? new Text(d) : new Textarea(d);
    return text;
  }
  if (d.fieldType === "DATETIME") {
    return new Datetime(d);
  }
  if (d.fieldType === "LIST") {
    if (d.listLimitType === "RADIO") {
      if (parseInt(d.displayType) === 3) {
        return new Radio(d);
      }
      if (parseInt(d.displayType) === 4) {
        return new Select(d);
      }
    }
    if (d.listLimitType === "CHECKBOX") {
      if (parseInt(d.displayType) === 5) {
        return new Checkbox(d);
      }
      if (parseInt(d.displayType) === 6) {
        return new CheckboxSelect(d);
      }
    }
  }
  if (d.fieldType === "FILE") {
    return new UploadFile(d);
  }
  return null;
}

export function updateDirty(list) {
  let isVerify = true;
  let field = [];
  cr.each(list, d => {
    if (d.fieldName === "avatar") {
      if (d.value) {
        field.push({
          fieldName: d.fieldName,
          value: {
            fileName: d.value.fieldName,
            mapId: d.value.mapId
          }
        });
      } else {
        field.push({
          fieldName: d.fieldName,
          value: ""
        });
      }
    } else {
      field.push({
        fieldName: d.fieldName,
        value: d.value
      });
    }

    d.dirty = true;
    d.sensitivDirty = true;
    if (d.invalid) {
      isVerify = false;
    }
  });
  return {
    isVerify: isVerify,
    field: field
  };
}
